import { DriveItemsResponse } from '@/drive/entities/DriveItemsResponse';
import { toAccessInheritanceSubject } from '@/drive/helpers/toAccessInheritanceSubject';
import { AccessInheritanceResponse } from '@/drive/types/AccessInheritanceResponse';
import { AccessInheritanceSubject } from '@/drive/types/AccessInheritanceSubject';
import { EntityAccessChange, EntityAccessChangedEvent } from '@/security/services/EntityAccessEventEmitter';
import { AccessTargetType } from '@/security/types/AccessTarget';

interface EntityAccessUpdate extends EntityAccessChange {
  targetType: AccessTargetType;
}

export function getAddedItemAccessChanges(res: DriveItemsResponse): EntityAccessChangedEvent[] {
  const updates = res
    .getItems()
    .map(toAccessInheritanceSubject)
    .filter((subject): subject is AccessInheritanceSubject => subject !== null)
    .map((subject) => ({ targetType: subject.targetType, id: subject.id, access: subject.access }));

  return toAccessChangedEvents(updates);
}

export function toEntityAccessChanges(responses: AccessInheritanceResponse[]): EntityAccessChangedEvent[] {
  const updates = responses
    .filter((response) => response.state === 'ok')
    .map((response) => ({ targetType: response.type, id: Number(response.id), access: response.access }));

  return toAccessChangedEvents(updates);
}

function toAccessChangedEvents(updates: EntityAccessUpdate[]): EntityAccessChangedEvent[] {
  const changesByTargetType = new Map<AccessTargetType, EntityAccessChange[]>();

  updates.forEach(({ targetType, id, access }) => {
    const changes = changesByTargetType.get(targetType) ?? [];

    changes.push({ id, access });
    changesByTargetType.set(targetType, changes);
  });

  return [...changesByTargetType.entries()].map(([targetType, changes]) => ({ targetType, changes }));
}
